export const EnvVars = {
  SITE_NAME: 'Nossa Vaquinha',
  URL: process.env.NEXT_PUBLIC_APP_URL,
  API_URL: process.env.NEXT_PUBLIC_API_URL,
  PAYMENT_GATEWAY_PUBKEY: process.env.NEXT_PUBLIC_PAYMENT_GATEWAY_PUBKEY,
  GA_TAG_ID: process.env.NEXT_PUBLIC_GA_TAG_ID,
  RECAPTCHA_SITE_KEY: process.env.RECAPTCHA_SITE_KEY,
};
